import React from "react";
import { Link } from "react-router-dom";

// Style \\
import "../../assets/styles/modal/navbarModal.scss";

// Icons \\
import { IoMdCloseCircleOutline } from "react-icons/io";

const NavbarModal = (props) => {
  const { navModal, active, setActive } = props;

  return (
    <div>
      <div className={`navbarModal ${active ? "active" : ""}`}>
        <div className="navbarModal_items">
          <div className="logo">
            <Link to={"/"} className="header_items_logo_link">
              med<span>dical</span>
            </Link>
            <div className="burger_icons">
              <IoMdCloseCircleOutline onClick={navModal} className="burger" />
            </div>
          </div>

          <div className="ul_box">
            <ul>
              <li>
                <Link to={"/"} onClick={navModal} className="nav_link">
                  Home
                </Link>
              </li>
              <li>
                <Link to={"/aboutUs"} onClick={navModal} className="nav_link">
                  About us
                </Link>
              </li>
              <li>
                <Link to={"/services"} onClick={navModal} className="nav_link">
                  Service
                </Link>
              </li>
              <li>
                <Link to={"/doctors"} onClick={navModal} className="nav_link">
                  Doctors
                </Link>
              </li>
              <li>
                <Link to={"/news"} onClick={navModal} className="nav_link">
                  News
                </Link>
              </li>
              <li>
                <Link to={"/contact"} onClick={navModal} className="nav_link">
                  Contact
                </Link>
              </li>
            </ul>

            <div className="buttons">
              <div className="appointment">
                <Link
                  to={"/appointment"}
                  onClick={navModal}
                  className="appointment_link"
                >
                  Appointment
                </Link>
              </div>

              <select name="lang" id="lang">
                <option value="Uzbek">Uzbek</option>
                <option value="Rus">Rus</option>
                <option value="Eng">Eng</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NavbarModal;
